// English + Spanish translations for NPCMOP site.
// Brand names (NPCMOP, Messengers of Peace, Holy Fire, Pre Camp Rally) intentionally kept in English.

export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      leadership: "Leadership",
      events: "Events",
      getInvolved: "Get Involved",
      give: "Give",
      contact: "Contact"
    },
    common: {
      learnMore: "Learn More",
      registerNow: "Register Now",
      viewAll: "View All",
      viewAllEvents: "View All Events",
      tagline: "A Generation on Fire for God",
      joinNow: "Join Now",
      contactUs: "Contact Us"
    },
    footer: {
      contactUs: "Contact Us",
      rightsReserved: "All rights reserved.",
      tagline: "A Generation on Fire for God"
    },
    home: {
      heroLine1: "A Generation",
      heroLine2: "on Fire",
      heroLine3: "for God",
      ctaDonate: "Donate to NPCMOP",
      ctaEvents: "Upcoming Events",
      whatIs: "What is",
      whatIsBody: "Uniting 33 local churches in Northern California, the NPCMOP district proudly serves a growing community of 700+ young people!",
      learnAboutUs: "Learn More About Us",
      momentsBadge: "Moments",
      momentsTitle: "A Movement",
      momentsTitleAccent: "in Motion",
      moment1Cat: "Prayer",
      moment1Title: "We carry one another.",
      moment2Cat: "Worship",
      moment2Title: "Lifted hands.",
      moment3Cat: "Vision Night",
      moment3Title: "Anointed to",
      moment3TitleAccent: "Multiply.",
      moment4Cat: "Camp",
      moment4Title: "Hearts on fire.",
      moment5Cat: "Revive",
      moment5Title: "One voice.",
      moment5TitleAccent: "One Spirit.",
      featuredBadge: "Featured Events",
      featuredBadgeSingle: "Featured Event",
      dontMissTitle: "Don't",
      dontMissAccent: "Miss Out",
      whatsNextBadge: "What's Next",
      upcomingEventsTitle: "Upcoming",
      upcomingEventsAccent: "Events",
      hsStudentReg: "High School Student Registration",
      hsCounselorReg: "Camp Counselor Registration",
      ctaReadyTitle: "Ready to Make",
      ctaReadyAccent: "an Impact?",
      ctaReadyBody: "Join a movement of young believers transforming the world for Christ",
      ctaGetInvolved: "Get Involved Today"
    },
    about: {
      badge: "About Us",
      heroLine1: "Northern Pacific",
      heroLine1Accent: "District",
      heroLine2: "Messengers of Peace",
      heroSubtitle: "Raising up a generation on fire for God",
      missionBadge: "Our Mission",
      missionTitleAccent: "Build",
      missionTitleRest: "The Local Church",
      missionParagraph0: "We firmly believe in the local church. It's where disciples are formed, lives are transformed, and souls are saved.",
      missionParagraph1: "We can't afford to neglect the local church; it's the foundation of a strong district, not the other way around.",
      missionParagraph2: "One of the ways we're committed to building the local church is by developing and nurturing leaders. We offer various leadership opportunities and projects that help refine and enhance their skills and gifts — enabling them to return to their local churches and make a positive impact.",
      missionParagraph3: "Additionally, we strive to create more opportunities for youth and young adults to encounter God and deepen their relationship with Him.",
      togetherBadge: "Together",
      togetherTitle: "Disciples are",
      togetherAccent: "formed",
      togetherTitleEnd: "here.",
      holyFireBadge: "2026 Vision",
      holyFireTitle: "Holy",
      holyFireAccent: "Fire",
      coreValuesBadge: "Core Values",
      coreValuesTitle: "What We",
      coreValuesAccent: "Believe In"
    },
    events: {
      badge: "Events",
      heroTitle: "What's",
      heroAccent: "Happening",
      heroSubtitle: "Join us for life-changing events, worship nights, and community gatherings",
      noEventsTitle: "No upcoming events",
      noEventsBody: "Check back soon for new events!"
    },
    leadership: {
      badge: "Our Team",
      heroTitle: "Meet the",
      heroAccent: "Leaders",
      heroSubtitle: "Passionate individuals dedicated to raising up the next generation"
    },
    getInvolved: {
      badge: "Get Involved",
      heroTitle: "Find Your",
      heroAccent: "Place",
      heroSubtitle: "Use your gifts to make an eternal impact. There's a place for you here.",
      readyTitle: "Ready to",
      readyAccent: "Join Us?",
      readyBody: "Click below to fill out our ministry application form",
      openForm: "Open Application Form"
    },
    give: {
      badge: "Give",
      heroTitle: "Support",
      heroAccent: "NPCMOP",
      heroSubtitle: "Your generosity helps empower young believers across the Northern Pacific District",
      venmoTitle: "Venmo",
      venmoDesc: "Quick mobile payments",
      venmoHandle: "Venmo Handle",
      qrSoonPrefix: "QR code coming soon! For now, search",
      qrSoonSuffix: "in the Venmo app",
      openVenmo: "Open Venmo",
      zelleTitle: "Zelle",
      zelleDesc: "Direct bank transfer",
      zelleSendTo: "Send to",
      zelleHowTitle: "How to give via Zelle:",
      zelleStep1: "Open your banking app",
      zelleStep2: "Select \"Send money with Zelle\"",
      zelleStep3: "Enter:",
      zelleStep4: "Enter amount and send!",
      copy: "Copy",
      copied: "Copied!",
      copiedToast: "Copied!",
      copiedVenmoBody: "Venmo handle copied to clipboard",
      copiedZelleBody: "Zelle email copied to clipboard",
      thankYouTitle: "Thank You for Your",
      thankYouAccent: "Generosity",
      thankYouBody: "Your support makes it possible to reach young people across the Northern Pacific District with the message of hope and empower them to make a difference in their communities."
    },
    contact: {
      badge: "Contact Us",
      heroTitle: "Get in",
      heroAccent: "Touch",
      heroSubtitle: "Have questions? Want to learn more? We'd love to hear from you!",
      sendBadge: "Send a Message",
      sendTitle: "We're Here to",
      sendAccent: "Help",
      sendBodyForm: "Fill out our contact form and we'll respond within 24-48 hours",
      sendBodyEmail: "Send us an email and we'll get back to you soon",
      cardBodyForm: "Click below to open our contact form",
      cardBodyEmail: "Click below to send us an email",
      otherBadge: "Contact Information",
      otherTitle: "Other Ways to",
      otherAccent: "Connect",
      otherBody: "Reach out through any of these channels",
      getInTouchCard: "Get in Touch",
      openContactForm: "Open Contact Form",
      sendEmail: "Send Email",
      emailLabel: "Email",
      locationLabel: "Location",
      followUs: "Follow Us",
      followUsBody: "Stay connected on social media",
      availabilityTitle: "Contact Availability",
      availabilityHeadline: "Available 24/7",
      availabilityBody: "Reach us anytime via email or social media"
    }
  },

  es: {
    nav: {
      home: "Inicio",
      about: "Nosotros",
      leadership: "Liderazgo",
      events: "Eventos",
      getInvolved: "Participar",
      give: "Dar",
      contact: "Contacto"
    },
    common: {
      learnMore: "Más Información",
      registerNow: "Regístrate",
      viewAll: "Ver Todos",
      viewAllEvents: "Ver Todos los Eventos",
      tagline: "Una Generación en Fuego para Dios",
      joinNow: "Únete",
      contactUs: "Contáctanos"
    },
    footer: {
      contactUs: "Contáctanos",
      rightsReserved: "Todos los derechos reservados.",
      tagline: "Una Generación en Fuego para Dios"
    },
    home: {
      heroLine1: "Una Generación",
      heroLine2: "en Fuego",
      heroLine3: "para Dios",
      ctaDonate: "Donar a NPCMOP",
      ctaEvents: "Próximos Eventos",
      whatIs: "¿Qué es",
      whatIsBody: "Uniendo a 33 iglesias locales en el norte de California, el distrito NPCMOP sirve con orgullo a una creciente comunidad de más de 700 jóvenes.",
      learnAboutUs: "Conoce Más Sobre Nosotros",
      momentsBadge: "Momentos",
      momentsTitle: "Un Movimiento",
      momentsTitleAccent: "en Marcha",
      moment1Cat: "Oración",
      moment1Title: "Nos sostenemos los unos a los otros.",
      moment2Cat: "Adoración",
      moment2Title: "Manos levantadas.",
      moment3Cat: "Noche de Visión",
      moment3Title: "Ungidos para",
      moment3TitleAccent: "Multiplicar.",
      moment4Cat: "Campamento",
      moment4Title: "Corazones en fuego.",
      moment5Cat: "Revive",
      moment5Title: "Una voz.",
      moment5TitleAccent: "Un Espíritu.",
      featuredBadge: "Eventos Destacados",
      featuredBadgeSingle: "Evento Destacado",
      dontMissTitle: "No Te",
      dontMissAccent: "Lo Pierdas",
      whatsNextBadge: "Lo Que Sigue",
      upcomingEventsTitle: "Próximos",
      upcomingEventsAccent: "Eventos",
      hsStudentReg: "Registro de Estudiantes (Secundaria)",
      hsCounselorReg: "Registro de Consejeros",
      ctaReadyTitle: "¿Listo para Hacer",
      ctaReadyAccent: "un Impacto?",
      ctaReadyBody: "Únete a un movimiento de jóvenes creyentes transformando el mundo para Cristo",
      ctaGetInvolved: "Participa Hoy"
    },
    about: {
      badge: "Sobre Nosotros",
      heroLine1: "Distrito del",
      heroLine1Accent: "Pacífico Norte",
      heroLine2: "Messengers of Peace",
      heroSubtitle: "Levantando una generación en fuego para Dios",
      missionBadge: "Nuestra Misión",
      missionTitleAccent: "Edificar",
      missionTitleRest: "la Iglesia Local",
      missionParagraph0: "Creemos firmemente en la iglesia local. Es donde se forman discípulos, se transforman vidas y se salvan almas.",
      missionParagraph1: "No podemos darnos el lujo de descuidar la iglesia local; es el fundamento de un distrito fuerte, no al revés.",
      missionParagraph2: "Una de las formas en que nos comprometemos a edificar la iglesia local es desarrollando y nutriendo líderes. Ofrecemos diversas oportunidades y proyectos de liderazgo que ayudan a refinar y potenciar sus habilidades y dones — permitiéndoles regresar a sus iglesias locales y generar un impacto positivo.",
      missionParagraph3: "Adicionalmente, nos esforzamos en crear más oportunidades para que jóvenes y adultos jóvenes encuentren a Dios y profundicen su relación con Él.",
      togetherBadge: "Juntos",
      togetherTitle: "Los discípulos se",
      togetherAccent: "forman",
      togetherTitleEnd: "aquí.",
      holyFireBadge: "Visión 2026",
      holyFireTitle: "Holy",
      holyFireAccent: "Fire",
      coreValuesBadge: "Valores Fundamentales",
      coreValuesTitle: "En Qué",
      coreValuesAccent: "Creemos"
    },
    events: {
      badge: "Eventos",
      heroTitle: "Qué Está",
      heroAccent: "Sucediendo",
      heroSubtitle: "Únete a nosotros en eventos transformadores, noches de adoración y encuentros comunitarios",
      noEventsTitle: "No hay eventos próximos",
      noEventsBody: "¡Vuelve pronto para ver nuevos eventos!"
    },
    leadership: {
      badge: "Nuestro Equipo",
      heroTitle: "Conoce a los",
      heroAccent: "Líderes",
      heroSubtitle: "Personas apasionadas dedicadas a levantar a la próxima generación"
    },
    getInvolved: {
      badge: "Participa",
      heroTitle: "Encuentra Tu",
      heroAccent: "Lugar",
      heroSubtitle: "Usa tus dones para hacer un impacto eterno. Aquí hay un lugar para ti.",
      readyTitle: "¿Listo para",
      readyAccent: "Unirte?",
      readyBody: "Haz clic abajo para llenar nuestra solicitud de ministerio",
      openForm: "Abrir Formulario de Solicitud"
    },
    give: {
      badge: "Dar",
      heroTitle: "Apoya a",
      heroAccent: "NPCMOP",
      heroSubtitle: "Tu generosidad ayuda a empoderar a jóvenes creyentes en todo el Distrito del Pacífico Norte",
      venmoTitle: "Venmo",
      venmoDesc: "Pagos móviles rápidos",
      venmoHandle: "Usuario de Venmo",
      qrSoonPrefix: "¡El código QR estará disponible pronto! Por ahora, busca",
      qrSoonSuffix: "en la app de Venmo",
      openVenmo: "Abrir Venmo",
      zelleTitle: "Zelle",
      zelleDesc: "Transferencia bancaria directa",
      zelleSendTo: "Enviar a",
      zelleHowTitle: "Cómo dar por Zelle:",
      zelleStep1: "Abre la app de tu banco",
      zelleStep2: "Selecciona \"Enviar dinero con Zelle\"",
      zelleStep3: "Ingresa:",
      zelleStep4: "¡Ingresa el monto y envía!",
      copy: "Copiar",
      copied: "¡Copiado!",
      copiedToast: "¡Copiado!",
      copiedVenmoBody: "Usuario de Venmo copiado al portapapeles",
      copiedZelleBody: "Correo de Zelle copiado al portapapeles",
      thankYouTitle: "Gracias por Tu",
      thankYouAccent: "Generosidad",
      thankYouBody: "Tu apoyo hace posible alcanzar a los jóvenes del Distrito del Pacífico Norte con un mensaje de esperanza y empoderarlos para marcar la diferencia en sus comunidades."
    },
    contact: {
      badge: "Contáctanos",
      heroTitle: "Ponte en",
      heroAccent: "Contacto",
      heroSubtitle: "¿Tienes preguntas? ¿Quieres saber más? ¡Nos encantaría saber de ti!",
      sendBadge: "Envíanos un Mensaje",
      sendTitle: "Estamos Aquí para",
      sendAccent: "Ayudar",
      sendBodyForm: "Llena nuestro formulario de contacto y te responderemos en 24-48 horas",
      sendBodyEmail: "Envíanos un correo y te responderemos pronto",
      cardBodyForm: "Haz clic abajo para abrir nuestro formulario de contacto",
      cardBodyEmail: "Haz clic abajo para enviarnos un correo",
      otherBadge: "Información de Contacto",
      otherTitle: "Otras Formas de",
      otherAccent: "Conectar",
      otherBody: "Comunícate a través de cualquiera de estos canales",
      getInTouchCard: "Ponte en Contacto",
      openContactForm: "Abrir Formulario de Contacto",
      sendEmail: "Enviar Correo",
      emailLabel: "Correo Electrónico",
      locationLabel: "Ubicación",
      followUs: "Síguenos",
      followUsBody: "Mantente conectado en redes sociales",
      availabilityTitle: "Disponibilidad",
      availabilityHeadline: "Disponibles 24/7",
      availabilityBody: "Contáctanos en cualquier momento por correo o redes sociales"
    }
  }
};
